import { render } from "./Emails.vue?vue&type=template&id=23bb181c&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=js"
export * from "./Emails.vue?vue&type=script&lang=js"

import "./Emails.vue?vue&type=style&index=0&id=23bb181c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23bb181c"]])

export default __exports__